<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex float-right align-items-center mb-2">
                <div class="input-group border-bottom position-relative" style="width: 190px">
                    <input
                        class="form-control bg-transparent border-none pr-4"
                        :placeholder="$t('common.search')"
                        aria-label="Search"
                        v-model="searchKeyword"
                        style="min-width: 190px"
                    />
                    <i
                        class="fa fa-search position-absolute"
                        style="top: 50%; right: 4px; margin-top: -6px"
                    />
                </div>
                <div class="mx-3 font-20">|</div>
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary mr-2" @click="openConfigModal">
                        <i class="fa fa-wrench mr-2"></i>
                        <span class="text-uppercase">Cấu hình</span>
                    </b-button>
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Tạo mới</span>
                    </b-button>
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="listPoint"
                :fields="fields"
                show-empty
                :filter="searchKeyword"
                :filter-included-fields="['name']"
            >
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(layerId)="data">{{ data.item.layer?.name }}</template>
                <template v-slot:cell(chartType)="data">{{
                    data.item.chartType == 'line' ? 'Đường' : 'Cột'
                }}</template>
                <template v-slot:cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button
                        variant="primary"
                        class="mr-1 min-width-none"
                        @click="openEditModal(row.item)"
                        v-b-tooltip.hover
                        :title="$t('common.edit')"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        variant="success"
                        class="mr-1 min-width-none"
                        @click="openDataModal(row.item)"
                        v-b-tooltip.hover
                        title="Xem dữ liệu"
                    >
                        <i class="fa fa-eye"></i>
                    </b-button>
                    <b-button
                        variant="warning"
                        class="mr-1 min-width-none"
                        @click="openChartModal(row.item)"
                        v-b-tooltip.hover
                        title="Xem biểu đồ"
                    >
                        <i class="fa fa-bar-chart"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có dữ liệu</span>
                    </div>
                </template>
            </b-table>
            <b-modal
                ref="createOrUpdateModal"
                :title="`${form.id ? $t('common.update') : $t('common.create')}`"
                ok-title="Lưu"
                @ok="handleCreateOk"
                :cancel-title="$t('common.cancel')"
            >
                <b-form-group label="Tên">
                    <b-form-input
                        v-model="form.name"
                        v-validate="'required'"
                        placeholder="Tên"
                        name="name"
                        data-vv-as="Tên"
                    ></b-form-input>
                    <div v-show="errors.has('name')" class="validation-message text-danger">
                        {{ errors.first('name') }}
                    </div>
                </b-form-group>
                <b-form-group label="Vĩ độ">
                    <b-form-input
                        v-model="form.lat"
                        v-validate="'required'"
                        placeholder="Vĩ độ"
                        name="lat"
                        type="number"
                        data-vv-as="Vĩ độ"
                    ></b-form-input>
                    <div v-show="errors.has('lat')" class="validation-message text-danger">
                        {{ errors.first('lat') }}
                    </div>
                </b-form-group>
                <b-form-group label="Kinh độ">
                    <b-form-input
                        v-model="form.long"
                        v-validate="'required'"
                        placeholder="Kinh độ"
                        type="number"
                        name="long"
                        data-vv-as="Kinh độ"
                    ></b-form-input>
                    <div v-show="errors.has('long')" class="validation-message text-danger">
                        {{ errors.first('long') }}
                    </div>
                </b-form-group>
                <b-form-group label="Loại biểu đồ">
                    <b-form-radio-group v-model="form.chartType">
                        <b-form-radio value="line">Đường</b-form-radio>
                        <b-form-radio value="bar">Cột</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
                <b-form-group label="Liên kết tới lớp dữ liệu">
                    <treeselect
                        :searchable="false"
                        :options="listLayerMap"
                        :normalizer="normalizer"
                        v-model="form.layerId"
                        placeholder="Chọn lớp dữ liệu"
                    />
                </b-form-group>
            </b-modal>
            <b-modal
                ref="configModal"
                title="Cấu hình"
                ok-title="Lưu"
                @ok="handleSetupColorOk"
                :cancel-title="$t('common.cancel')"
            >
                <b-form-group label="Dữ liệu chính">
                    <v-select
                        v-model="mainData"
                        :options="listDataType"
                        :clearable="false"
                        :filterable="false"
                        :searchable="false"
                    ></v-select>
                </b-form-group>
                <b-row class="mb-1">
                    <b-col cols="4">
                        <b-form-label>Tên</b-form-label>
                    </b-col>
                    <b-col cols="3">
                        <b-form-label>Màu sắc</b-form-label>
                    </b-col>
                    <b-col cols="5">
                        <b-form-label>Giá trị giới hạn</b-form-label>
                    </b-col>
                </b-row>
                <b-row v-for="item in legend" :key="item" class="mb-2">
                    <b-col cols="4">
                        <b-form-input v-model="item.name"></b-form-input>
                    </b-col>
                    <b-col cols="3">
                        <b-form-input v-model="item.color" type="color"></b-form-input>
                    </b-col>
                    <b-col cols="5">
                        <b-row no-gutters>
                            <b-col cols="8">
                                <b-form-input v-model="item.value" type="number"></b-form-input>
                            </b-col>
                            <b-col cols="4" class="pl-2">
                                <b-button
                                    variant="danger"
                                    @click="legend.splice(legend.indexOf(item), 1)"
                                    >Xoá</b-button
                                >
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-button variant="primary" @click="legend.push({ color: '#000' })"
                    >Thêm cấp màu</b-button
                >
            </b-modal>
            <b-modal ref="dataModal" size="xl" title="Dữ liệu" hide-footer>
                <DataPoint :pointId="selectedPoint?.id" />
            </b-modal>
            <b-modal
                hide-header
                hide-footer
                centered
                size="xl"
                modal-class="station-modal"
                ref="chartModal"
            >
                <Statistic :point="selectedPoint" />
            </b-modal>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DataPoint from '@/components/DataPoint';
import Statistic from '@/components/Statistic';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
    components: {
        DatePicker,
        DataPoint,
        Treeselect,
        Statistic
    },
    async mounted() {
        await this.$nextTick();
        this.listDataType = await this.getDataType();
        const config = await this.getConfig({ id: 'point' });
        this.mainData = config?.value?.mainData;
        this.legend = config?.value?.legend || [
            { color: '#ff0000' },
            { color: '#ffa500' },
            { color: '#008000' }
        ];
        this.listPoint = await this.getList();
        this.listLayerMap = await this.getLayerTree({ type: 'layer' });
    },
    data: function() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'name',
                    label: 'Tên'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'lat',
                    label: 'Vĩ độ'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'long',
                    label: 'Kinh độ'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'chartType',
                    label: 'Loại biểu đồ'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'layerId',
                    label: 'Lớp dữ liệu liên kết'
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '200px' }
                }
            ],
            form: {},
            searchKeyword: null,
            listPoint: [],
            selectedPoint: null,
            listData: [],
            file: null,
            listLayerMap: [],
            legend: [],
            listDataType: [],
            mainData: null
        };
    },
    methods: {
        ...mapActions({
            getList: 'point/getList',
            create: 'point/create',
            delete: 'point/delete',
            update: 'point/update',
            getLayerTree: 'mapLayer/getListTree',
            getConfig: 'config/get',
            createConfig: 'config/create',
            getDataType: 'data/getDataType',
            createAuditByUser: 'user/createAuditByUser'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitForm();
                }
            });
        },
        async openEditModal(item) {
            this.form = { ...item };
            this.$refs.createOrUpdateModal.show();
        },
        async openDataModal(item) {
            this.selectedPoint = item;
            this.$refs.dataModal.show();
        },
        async openChartModal(item) {
            this.selectedPoint = item;
            this.$refs.chartModal.show();
        },
        openCreateModal() {
            this.form = { chartType: 'line' };
            this.$refs.createOrUpdateModal.show();
        },
        async confirmDelete(item) {
            const result = await this.$bvModal.msgBoxConfirm('Bạn có chắc chắn muốn xoá không?', {
                title: 'Xác nhận',
                okVariant: 'danger',
                okTitle: 'Có',
                cancelTitle: 'Không'
            });
            if (result) {
                await this.delete(item);
                this.listPoint = await this.getList();
                this.$toaster.success('Xoá thành công');
                this.createAuditByUser({ content: 'Xoá điểm' });
            }
        },
        async submitForm() {
            if (this.form.id) {
                await this.update({ ...this.form, layerId: this.form.layerId || null });
            } else {
                await this.create(this.form);
            }
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Cập nhật điểm' });
            this.listPoint = await this.getList();
            this.$refs.createOrUpdateModal.hide();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },
        openConfigModal() {
            this.$refs.configModal.show();
        },
        async handleSetupColorOk(modal) {
            modal.preventDefault();
            await this.createConfig({
                key: 'point',
                value: {
                    legend: this.legend,
                    mainData: this.mainData
                }
            });
            this.$toaster.success('Thành công');
            this.$refs.configModal.hide();
        }
    }
};
</script>
